module.exports = __webpack_public_path__ + "static/media/spacelabs-healthcare.35f118d8.svg";